import { PluginEquifaxPpsrGrantorSearchFormResponse } from '~/core/shared/types/plugins';
import { Option } from '~/core/shared/types/utility';

export const grantorToSelectOption = (
  grantor: PluginEquifaxPpsrGrantorSearchFormResponse['grantors'][number],
): Option<string> => ({
  label: grantor.label,
  value: grantor.id,
});
